<div [innerHTML]="html | safeHtml" class="md-margin"></div>